import { render, staticRenderFns } from "./EditAddressSidebar.vue?vue&type=template&id=4bc56939&scoped=true&"
import script from "./EditAddressSidebar.vue?vue&type=script&lang=js&"
export * from "./EditAddressSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EditAddressSidebar.vue?vue&type=style&index=0&id=4bc56939&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc56939",
  null
  
)

export default component.exports